import React from 'react'
import { ComingSoonEmailCapture } from './ComingSoon'
import { LiveCTAs } from './LiveCTAs'

export interface CtaStrategyProps {
  camp: {
    slug: string
    isLive: boolean
  }
}

export const CtaStrategy = ({ camp }: CtaStrategyProps) => (
  <>
    {camp.isLive ? (
      <LiveCTAs slug={camp.slug} />
    ) : (
      <ComingSoonEmailCapture slug={camp.slug} />
    )}
  </>
)
